import React from "react";
import "./ContentBlock.scss";

function ContentBlock(props) {
  return <div className="ContentBlock bloco-conteudo">{props.children}</div>;
}

export default ContentBlock;
